import { render, staticRenderFns } from "./Brooklyn.vue?vue&type=template&id=570633f0&scoped=true"
import script from "./Brooklyn.vue?vue&type=script&lang=js"
export * from "./Brooklyn.vue?vue&type=script&lang=js"
import style0 from "./Brooklyn.vue?vue&type=style&index=0&id=570633f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570633f0",
  null
  
)

export default component.exports